var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section-login__header" }, [
    _c("div", { staticClass: "section-login__header__bg" }, [
      !_vm.isWhitelabel
        ? _c("img", {
            staticClass: "lazy",
            attrs: {
              src: require("@/assets/images/pass-recovery-bg.png"),
              alt: "login background",
              "data-load-priority": "0"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "loginv2-container container" }, [
        _c(
          "h1",
          {
            staticClass: "title md-title",
            class: { "title--ringba": !_vm.isWhitelabel }
          },
          [_c("span", { staticClass: "login-welcome-message" })]
        ),
        _vm._v(" "),
        _vm._m(0)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "subtitle" }, [
      _c("span", { staticClass: "login-welcome-sub-message" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }